'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/
  workRegex2 = /^.*next\..*\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1 or workRegex2.test(location.href) is true
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

$id = $('body').attr('id')
$class = $('body').attr('class')

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

headerHight = $('.l-header__inner').outerHeight()
#ヘッダの高さ
$('a[href^="#"]').on('click',
  (e)->
    href = $(this).attr('href')
    target = $(if href is '#' or href is '' then 'html' else href)
    position = target.offset().top - headerHight
    #ヘッダの高さ分位置をずらす
    $('html, body').animate({ scrollTop: position }, 550, 'swing')
    false
    return
)

#spナビ開く処理
spNavIn = ->
  $('body').addClass('navi-open')
  $('.l-header-navi').animate({ opacity: 1 }, 200)
  return

#spナビ閉じる処理
spNavOut = ->
  $('.l-header-navi').animate({ opacity: 0 }, 200)
  $('body').removeClass('navi-open')
  return

#spナビ開閉処理
spNavInout = ->
  if $('body').hasClass('navi-open')
    spNavOut()
  else
    spNavIn()
  return

$('.l-header-humburger').on('click',
  (e)->
    spNavInout()
    return
)

$('.c-accordion').on('click',
  (e)->
    if window.matchMedia('(max-width:640px)').matches
    else
      $('#sub').css('min-height', $('#main').outerHeight(true))
)

# 固定コンテンツ制御
fixedContents =
  (offFlg)->
    if $class.indexOf('home') is -1 and ($class.indexOf('index') is -1 or $class.indexOf('doctor') is -1) and $class.indexOf('mail') is -1 and $class.indexOf('privacy-policy') is -1
      mainHeight = $('#main').height()
      subHeight = $('#sub').height()

      if subHeight < mainHeight
        $('#sub').css('min-height', $('#main').outerHeight(true))

        mainContentsHeight = $('#main').outerHeight(true)
        subContentsHeight = $('#sub').outerHeight(true)
        windowHeight = $(window).height()
        # 30 = メニュー下マージン
        adjustMargin = $('.l-header').outerHeight() + 30
        # adjustMargin = $('#gnavi').outerHeight() + 0

        $fixContents = $('.l-side__inner')
        fixContentsHeight = $('.l-side__inner').outerHeight(true)
        fixContentsPos = $fixContents.offset().top - adjustMargin

        fixFlg = false
        bottomFlg = false

        initial = ()->
          # メインコンテンツの高さが変わった時時再度高さ適応
          currentSubHeight = $('#sub').outerHeight(true)
          currentMainContentsHeight = $('#main').outerHeight(true)

          # if currentMainContentsHeight > mainContentsHeight
            # $('#sub').removeAttr('style')
          $('#sub').css('min-height', currentMainContentsHeight)

          currentSubContentsHeight = $('#sub').outerHeight(true)

          # メニュー開閉等で位置が変わった時再計算
          currentFixContentsPos = $('.l-side__inner').offset().top - adjustMargin

          if $('.l-side__inner').not('.is-fixed,.is-bottom').length isnt 0
            #currentFixContentsPos = $('.l-side__inner').not('.is-fixed,.is-bottom').offset().top - adjustMargin

            if currentFixContentsPos > fixContentsPos
              fixContentsPos = currentFixContentsPos

          # サブコンテンツの方が高さが低い時のみ実行
          if currentSubContentsHeight <= currentMainContentsHeight
            scrollPos = $(window).scrollTop()
            fixContentsBottomPos = $('.l-container').height() - (scrollPos + windowHeight) - $('#footer').outerHeight() - ((adjustMargin + fixContentsHeight) - windowHeight)

            if scrollPos > fixContentsPos
              if not fixFlg and not bottomFlg
                $fixContents.addClass('is-fixed')
                fixFlg = true
            else
              $fixContents.removeClass('is-fixed')
              if fixFlg
                fixFlg = false

            if fixContentsBottomPos < 80
              $fixContents.removeClass('is-fixed')
              if fixFlg
                fixFlg = false

                if window.matchMedia('(max-width:640px)').matches
                else
                  if not bottomFlg
                    $fixContents.addClass('is-bottom')
                    bottomFlg = true
            else
              if bottomFlg
                $fixContents.removeClass('is-bottom').addClass('is-fixed')
                bottomFlg = false

        initial()

        $(window).on('scroll.fixedContents resize.fixedContents',
          ()->
            if offFlg is true
              $(window).off('scroll.fixedContents resize.fixedContents')
              $('#main').removeAttr('style')
              $('#sub').removeAttr('style')
              $('.l-side__inner').off()
              $('.l-side__inner').removeClass('is-fixed')
              $('.l-side__inner').removeClass('is-bottom')
            else
              initial()
        )

$(window).on('load',
  ()->
    hash = location.hash

    if window.matchMedia('(max-width:640px)').matches
      currentScrollPos = 0
      firstView = 'SP'
    else
      firstView = 'PC'
      if $('.l-side').length isnt -1
        fixedContents()
)

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:640px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
        fixedContents(true)

        currentScrollPos = 0

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
        firstView = 'PC'
        if $('.l-side').length isnt -1
          fixedContents()

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false
)

